import React from "react";
import { FaCheck } from "react-icons/fa";
import "../App.css";

const ReasonsSection = () => {
  return (
    <div className="reasons-section container mt-5">
      <h3 className="coach">
        WHY I OFFER CALISTHENIC <br /> TRAINING?
      </h3>

      {/* TOP 3 ITEMS */}
      <div className="parent">
        <div className="reason-box">
          <div className="check">
            <FaCheck className="check-mark" />
          </div>
          <p className="calistehenic-h">
            Sustainable strength for <br /> real life
          </p>
          <p className="calistehenic-p">
            The strength you gain translates to daily activity, not just gym numbers.
          </p>
        </div>

        <div className="reason-box">
          <div className="check">
            <FaCheck className="check-mark" />
          </div>
          <p className="calistehenic-h">Anywhere, anytime</p>
          <p className="calistehenic-p">
            Either you’re traveling, at home, or in a gym, you can always train.
          </p>
        </div>

        <div className="reason-box">
          <div className="check">
            <FaCheck className="check-mark" />
          </div>
          <p className="calistehenic-h">Joint Family progression</p>
          <p className="calistehenic-p">
            We emphasize control, technique, and gradual load so your joints and connective tissues stay healthy.
          </p>
        </div>
      </div>

      {/* BOTTOM 2 ITEMS */}
      <div className="calisthenics mt-4">
        <div className="reason-box">
          <div className="check-marks">
            <FaCheck className="check-mark" />
          </div>
          <p className="calistehenic-h">Skill + strength combined</p>
          <p className="calistehenic-p">
            It’s not just about reps — it’s about learning movement capacity (handstands, levers, muscle-ups).
          </p>
        </div>

        <div className="reason-box">
          <div className="check-marks">
            <FaCheck className="check-mark" />
          </div>
          <p className="calistehenic-h">Flexible for all levels</p>
          <p className="calistehenic-p">
            Beginners to advanced — I tailor everything to your starting point.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReasonsSection;
